module.exports = "<span>地図情報提供：国土地理院</span>\n"